import { gsap} from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const init = () => {
  const hasIndexPurposeScrollLinks = document.querySelectorAll('.js-purposeScrollLink[data-index]');
  if (hasIndexPurposeScrollLinks.length) {
    hasIndexPurposeScrollLinks.forEach((link) => {
      const targetId = link.getAttribute('data-id');
      const targetIndex = link.getAttribute('data-index');
      const targetPurposeScrollImage = document.querySelector(`.js-purposeScrollImage[data-name="${targetId}"]`);
      targetPurposeScrollImage.style.zIndex = targetIndex;

      const targetPurposeScroll = document.querySelector(`.js-purposeScroll[data-id="${targetId}"]`);
      targetPurposeScroll.style.order = targetIndex;
    });
  }


  const purposeScrollElms = document.querySelectorAll('.js-purposeScroll');
  const purposeScrollImageElms = document.querySelectorAll('.js-purposeScrollImage');
  if (!purposeScrollElms.length) return;

  purposeScrollElms.forEach((purposeScroll, index) => {
    gsap.to(purposeScrollImageElms[index], {
      opacity: 1,
      duration: 0.3,
      scrollTrigger: {
        trigger: purposeScroll,
        start: 'top center',
        end: 'bottom top',
        toggleActions: 'play none play reverse'
      },
    });
  });
}

export {
  init
}
